"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminProfileLangFactory = /** @class */ (function () {
    function AdminProfileLangFactory() {
    }
    AdminProfileLangFactory.getEN = function () {
        return {
            document_title: "User profile",
            msg_data_updated: "Data updated !",
            msg_data_loaded: "Data loaded !",
            msg_pwd_changed: "Password was succesfully changed !",
            editor_title: "Edit profile of user : ",
            fc_admin_name: "Administrator name:",
            fp_admin_name: "Enter administrator's name",
            fc_admin_surname: "Administrator surname:",
            fp_admin_surname: "Enter administrator's surname",
            fc_admin_skype: "Administrator Skype:",
            fp_admin_skype: "Enter administrator skype",
            fc_admin_email: "Administrator EMail:",
            fp_admin_email: "Enter administrator email",
            fc_admin_phone: "Administrator phone:",
            fp_admin_phone: "Enter administrator phone",
            b_load_data: "Load data",
            b_save_data: "Save data",
            b_pwd_change: "Change password"
        };
    };
    AdminProfileLangFactory.getRU = function () {
        return {
            document_title: "Профиль пользователя",
            msg_data_updated: "Данные обновлены !",
            msg_data_loaded: "Данные загружены !",
            msg_pwd_changed: "Пароль был успешно изменен !",
            editor_title: "Редактировать профиль пользователя : ",
            fc_admin_name: "Имя администратора:",
            fp_admin_name: "Введите имя администратора",
            fc_admin_surname: "Фамилия администратора:",
            fp_admin_surname: "Введите фамилию администратора",
            fc_admin_skype: "Skype администратора:",
            fp_admin_skype: "Введите skype администратора",
            fc_admin_email: "EMail администратора:",
            fp_admin_email: "Введите email администратора",
            fc_admin_phone: "Телефон администратора:",
            fp_admin_phone: "Введите телефон администратора",
            b_load_data: "Загрузить данные",
            b_save_data: "Сохранить данные",
            b_pwd_change: "Изменить пароль",
        };
    };
    AdminProfileLangFactory.getLangInstance = function (Lang) {
        if (Lang == "RU") {
            return this.getRU();
        }
        return this.getEN();
    };
    return AdminProfileLangFactory;
}());
exports.AdminProfileLangFactory = AdminProfileLangFactory;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/admin_profile/ui/lang/AdminProfileLang.ts
// module id = 1854
// module chunks = 0